<script lang="ts">
  import { onMount } from "svelte";
  import { apiFetch, ApiError } from "$lib/api";
  import type { ReportCardPageData } from "$lib/api";
  import ReportCardContent from "@/components/customer/features/ReportCardContent.svelte";

  interface Props {
    uuid: string;
  }

  let { uuid = "" }: Props = $props();

  type PublicReportCard = ReportCardPageData & { account_name?: string | null };

  let data = $state<PublicReportCard | null>(null);
  let loading = $state(true);
  let notFound = $state(false);
  let error = $state<string | null>(null);

  onMount(async () => {
    try {
      data = await apiFetch<PublicReportCard>(`/api/public/report_cards/${encodeURIComponent(uuid)}`);
    } catch (e) {
      if (e instanceof ApiError && e.status === 404) {
        notFound = true;
      } else {
        error = e instanceof Error ? e.message : String(e);
      }
    } finally {
      loading = false;
    }
  });
</script>

<div class="min-h-screen bg-background text-foreground px-4 py-10 sm:px-6 lg:px-8">
  <div class="mx-auto w-full max-w-3xl">
    {#if loading}
      <p class="text-center text-sm text-muted-foreground">Loading report card…</p>
    {:else if notFound}
      <div class="mx-auto max-w-2xl p-8 text-center">
        <h1 class="mb-2 text-4xl font-black text-primary">Report Card Not Found</h1>
        <p class="mt-4 text-xl font-light leading-normal text-muted-foreground">
          This report card link is no longer valid or doesn't exist.
        </p>
        <p class="mt-4 text-base text-muted-foreground">
          If you received this link from someone, ask them to share it again — it may have
          expired or been regenerated.
        </p>
      </div>
    {:else if error}
      <p class="text-center text-sm text-destructive">Something went wrong — {error}</p>
    {:else if data}
      <ReportCardContent {data} accountName={data.account_name ?? null} showHeader={true} />
    {/if}
  </div>
</div>
